// ✅ 10-digit mobile (no spaces, no symbols)
export function isTenDigitMobile(number) {
  const regex = /^(?!.*\s)\d{10}$/; // (?!.*\s) ensures no spaces anywhere
  return regex.test(number?.trim());
}

// ✅ Strict email (no spaces allowed)
export function isValidEmailStrict(email) {
  const regex = /^(?!.*\s)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email?.trim());
}

// ✅ Numbers only (no spaces)
export function isNumberOnly(value) {
  if (value === null || value === undefined) return false;
  const stringValue = String(value);
  const regex = /^(?!.*\s)\d+$/;
  return regex.test(stringValue.trim());
}

// ✅ Decimal numbers only (no spaces)
export function isDecimalNumber(value) {
  const regex = /^(?!.*\s)\d+(\.\d+)?$/;
  return regex.test(value?.trim());
}
